<template>

    <order-tax-table></order-tax-table>

</template>

<script>
import OrderTaxTable from "@/Pages/Sales/Order/Components/OrderTaxTable";
import AppLayout from "@/Layouts/AppLayout";
import Detail from "@/Pages/Sales/Order/Detail";

export default {
    components: {
        OrderTaxTable
    },
    layout: [AppLayout, Detail],

}
</script>

<style scoped>

</style>
